import React from 'react';
import { Icon } from 'antd';
import Flex from '../styled/Flex';
import colors from './theme';

const NoResultFound = () => (
	<Flex
		justifyContent="center"
		style={{
			minHeight: 150,
			position: 'absolute',
			top: 1,
			left: 2,
			right: 2,
			bottom: 2,
			zIndex: 999,
			background: colors.white,
		}}
		id="spinner"
		alignItems="center"
		flexDirection="column"
	>
		<Icon
			type="frown"
			theme="outlined"
			style={{ fontSize: 44, marginBottom: 20 }}
		/>
		No results found
	</Flex>
);

export default NoResultFound;
